import { render, staticRenderFns } from "./ColorBorder.vue?vue&type=template&id=747041d6&scoped=true"
import script from "./ColorBorder.vue?vue&type=script&lang=js"
export * from "./ColorBorder.vue?vue&type=script&lang=js"
import style0 from "./ColorBorder.vue?vue&type=style&index=0&id=747041d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747041d6",
  null
  
)

export default component.exports